import { ajax } from '../../../services/helper'

class ApiService {
    verifyEmailId = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/users/generatePasswordLink"
            ajax(url, 'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    verifyForgotPasswordToken = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/users/validatePasswordLink"
            ajax(url, 'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    resetPassword = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/users/resetForgotPassword"
            ajax(url, 'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
}

export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/ForgotPassword/services/apiservices.js